import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  Input,
  Select,
} from "../../../shared/ui/composites";
import {
  MIN_OPS,
  MAX_OPS,
  emptyBand,
  bandMinOp,
  bandMaxOp,
  patchBand,
} from "../../staff/utils/commissionConfig";

export default function BandTable({ table, onChange, extraHeader }) {
  const bands = table?.bands || [];

  const updateBand = (index, field, value) => {
    const next = bands.map((band, i) => (i === index ? patchBand(band, field, value) : band));
    onChange({ ...table, bands: next });
  };

  const addBand = () => onChange({ ...table, bands: [...bands, emptyBand()] });
  const removeBand = (index) =>
    onChange({ ...table, bands: bands.filter((_, i) => i !== index) });

  return (
    <Card className="overflow-hidden">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm">{table?.title || extraHeader}</CardTitle>
        <CardDescription>
          هر ردیف یک بازه درصد است. ردیف‌ها را اضافه یا حذف کنید؛ اولین بازهٔ منطبق اعمال می‌شود.
        </CardDescription>
      </CardHeader>
      {extraHeader}
      <div className="overflow-x-auto px-3 pb-3">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-slate-500">
              <th className="px-1 py-1 text-right">از</th>
              <th className="px-1 py-1 text-right">حد پایین</th>
              <th className="px-1 py-1 text-center">x</th>
              <th className="px-1 py-1 text-right">تا</th>
              <th className="px-1 py-1 text-right">حد بالا</th>
              <th className="px-1 py-1 text-right">{table?.output_label || "درصد اعمالی"}</th>
              <th className="w-8" />
            </tr>
          </thead>
          <tbody>
            {bands.map((band, index) => (
              <tr key={band.id || index} className="border-t border-slate-100">
                <td className="px-1 py-1">
                  <Select
                    variant="filter"
                    className="min-w-0 w-[3.5rem] px-1 py-1"
                    value={bandMinOp(band)}
                    onChange={(e) => updateBand(index, "minOp", e.target.value)}
                  >
                    {MIN_OPS.map((op) => (
                      <option key={op.value} value={op.value}>{op.label}</option>
                    ))}
                  </Select>
                </td>
                <td className="px-1 py-1">
                  <Input
                    type="number"
                    variant="form"
                    className="h-8 w-16 px-1"
                    step="0.01"
                    disabled={!bandMinOp(band)}
                    value={band.min ?? ""}
                    onChange={(e) => updateBand(index, "min", e.target.value)}
                  />
                </td>
                <td className="px-1 py-1 text-center text-slate-400">x</td>
                <td className="px-1 py-1">
                  <Select
                    variant="filter"
                    className="min-w-0 w-[3.5rem] px-1 py-1"
                    value={bandMaxOp(band)}
                    onChange={(e) => updateBand(index, "maxOp", e.target.value)}
                  >
                    {MAX_OPS.map((op) => (
                      <option key={op.value} value={op.value}>{op.label}</option>
                    ))}
                  </Select>
                </td>
                <td className="px-1 py-1">
                  <Input
                    type="number"
                    variant="form"
                    className="h-8 w-16 px-1"
                    step="0.01"
                    disabled={!bandMaxOp(band)}
                    value={band.max ?? ""}
                    onChange={(e) => updateBand(index, "max", e.target.value)}
                  />
                </td>
                <td className="px-1 py-1">
                  <label className="flex items-center gap-1">
                    <Input
                      type="number"
                      variant="form"
                      className="h-8 w-16 px-1"
                      step="0.01"
                      value={band.payout_percent ?? 0}
                      onChange={(e) => updateBand(index, "payout_percent", e.target.value)}
                    />
                    <span>%</span>
                  </label>
                </td>
                <td className="px-1 py-1">
                  <Button
                    type="button"
                    variant="ghost"
                    className="h-8 w-8 p-0 text-red-500"
                    onClick={() => removeBand(index)}
                    aria-label="حذف ردیف"
                  >
                    ×
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Button type="button" variant="outline" size="sm" className="mt-2" onClick={addBand}>
          + افزودن ردیف
        </Button>
      </div>
    </Card>
  );
}
